import { FC } from 'react'
import { Link } from 'react-router-dom'

import * as S from './styled'
import {
  WhoShape,
  UserIcon,
  ToolIcon,
  EadIcon,
  ProIcon,
  WhoSteps,
  ArcPlusIcon
} from '../../icons'

const Who: FC = () => (
  <S.Container>
    <S.Wrapper>
      <S.Content>
        <S.Title>
          <span>01</span> Quem pode participar?
        </S.Title>

        <S.InfoContainer>
          <S.Info>
            Há 4 categorias de <strong>participantes</strong>, sendo elas
            <S.Bar />
            <WhoShape />
          </S.Info>

          <S.InfoColumn>
            <S.InfoRow>
              <S.InfoBox $width={500}>
                <UserIcon />
                <h3>Cliente</h3>
                <p>
                  Pessoa física que compra e usa o produto como destinatário
                  final.
                </p>
              </S.InfoBox>

              <S.InfoBox>
                <ToolIcon />
                <h3>EAD</h3>
                <p>
                  Pessoas físicas, sendo engenheiros, arquitetos e decoradores
                  com cadastro ativo junto à LEROY MERLIN.
                </p>
              </S.InfoBox>
            </S.InfoRow>

            <S.InfoRow>
              <S.InfoBox $width={325} $height={240}>
                <EadIcon />
                <ArcPlusIcon />
                <p>
                  Arquitetos, com empresa própria (CNPJ) vinculada ao seu
                  cadastro.
                </p>
              </S.InfoBox>

              <S.InfoBox $height={240}>
                <ProIcon />
                <h3>Executor/ PRO</h3>
                <p>
                  Pessoas físicas sendo pedreiros, pintores, marceneiros,
                  eletricistas, encanadores, ceramistas, paisagistas,
                  jardineiros, serralheiros, carpinteiros, encanadores, entre
                  outros.
                </p>
              </S.InfoBox>
            </S.InfoRow>
          </S.InfoColumn>
        </S.InfoContainer>

        <S.InfoBottom>
          <h3>
            <span>Conta</span>
            <ArcPlusIcon />
          </h3>
          <p>
            <span>
              A categoria ARC+ atrelada ao Arquiteto é relacionado ao CNPJ da
              empresa. O cadastro no Programa de Fidelidade é realizado por
              pessoa física (CPF e CAU). Após o cadastro, o cliente vincula o
              CNPJ em sua conta ARC+ através do menu “Cashback” disponível na
              área logada do programa de Fidelidade.{' '}
              <Link to="/cadastre-se" target="_blank">
                <S.InfoLink>Cadastre-se</S.InfoLink>
              </Link>
              .
            </span>
            <WhoSteps />
          </p>
        </S.InfoBottom>
      </S.Content>
    </S.Wrapper>
  </S.Container>
)

export default Who
